import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import moment from 'moment'
//import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
//import SlideUpDown from 'vue-slide-up-down'
//import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack
import { rutInputDirective } from 'vue-dni'; // para config
import Axios from 'axios'
import slack from '@/plugins/slack'
//import VueVirtualScroller from 'vue-virtual-scroller'
//import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
//import VueCurrencyInput from 'vue-currency-input'

import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'

Vue.use(HighchartsVue)



if(window.location.hostname.split("agrogesttion.irricrops.com").length > 1){
  window.location.replace("http://darwin.irricrops.com");
}



Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD [de] MMMM , YYYY')
  }
})


const pluginOptions = {
  globalOptions: { currency: 'CLP', locale:"es-cl" }
}
//Vue.use(VueCurrencyInput, pluginOptions)
//Vue.use(VueVirtualScroller)
Vue.directive('rut', rutInputDirective);
//Vue.component('slide-up-down', SlideUpDown)
//Vue.component('v-chart', ECharts)
Vue.config.productionTip = false;
moment.locale('es');


Vue.prototype.$http = Axios;
const token = localStorage.getItem("token");
if (token) {
  store.commit('auth_success', token)
  store.dispatch("getDataUser").then(res => {
    slack.notify("ingreso a AG "+res.data.email);

  }, resError => {
      store.dispatch("logout").then(() => {
      router.push("/login");
    });
  });
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


